import { operationalScope } from './workstationIdentity';
// Queue ownership is fixed when a view mounts. Never infer ownership of legacy entries.
export function getOfflineAccountScope() {
  return operationalScope();
}

export function scopedOfflineKey(base, scope) {
  return `${base}:account:${encodeURIComponent(scope || 'unidentified')}`;
}

export function isOfflineScopeCurrent(scope) {
  return Boolean(scope) && scope === getOfflineAccountScope();
}

export function newOfflineId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function readOfflineEntries(key) {
  try {
    const entries = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(entries) ? entries : [];
  } catch (_) {
    return [];
  }
}
